/* Nolu: kurvens egne knapper. Ligger i en fil for sig, fordi temaet tegner kurven igen med
   innerHTML, og så køres scripts inde i kurven ikke.
   1. "+ Tilføj" i "Tilføj lidt ekstra" (snippets/hs-kurv-ekstra.liquid)
   2. Forsikret forsendelse til og fra (snippets/hs-forsikring.liquid)
   3. Ligger kun forsikringen tilbage i kurven, fjernes den */
(function () {
  if (window.__hsKurv) return;
  window.__hsKurv = true;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function post(path, body) {
    body.sections = ['cart-drawer', 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      var drawer = document.querySelector('cart-drawer');
      if (res && res.sections && drawer && typeof drawer.renderContents === 'function') drawer.renderContents(res);
      else window.location.reload();
      setTimeout(cleanup, 50);
      return res;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hs-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    b.textContent = '…';
    /* I 'Køb 1 mere, få 1 gratis' vælger kunden selv produktet i listen */
    var box = b.closest('.hs-gratis3');
    var sel = box && box.querySelector('select');
    post('cart/add.js', { items: [{ id: +(sel ? sel.value : b.getAttribute('data-hs-add')), quantity: 1 }] })
      .catch(function () { b.disabled = false; b.textContent = '+ Tilføj'; });
  });

  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-hs-prot]');
    if (!cb) return;
    cb.disabled = true;
    var p = cb.checked
      ? post('cart/add.js', { items: [{ id: +cb.getAttribute('data-hs-prot'), quantity: 1 }] })
      : post('cart/change.js', { id: cb.getAttribute('data-hs-prot-key'), quantity: 0 });
    p.catch(function () { cb.checked = !cb.checked; cb.disabled = false; });
  });

  var busy = false;
  function cleanup() {
    var only = document.querySelector('[data-hs-prot-only]');
    if (!only || busy) return;
    busy = true;
    post('cart/change.js', { id: only.getAttribute('data-hs-prot-only'), quantity: 0 })
      .then(function () { busy = false; }, function () { busy = false; });
  }
  /* Temaet ændrer kurven (antal, slet), uden at vi får besked: hold øje med den */
  function watch() {
    var d = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (!d || !('MutationObserver' in window)) return;
    new MutationObserver(function () { setTimeout(cleanup, 100); }).observe(d, { childList: true, subtree: true });
    cleanup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  /* Variantvælgerne i kurven er så brede som den valgte tekst, så pilen står lige ved teksten
     (en select er ellers lige så bred som den længste mulighed) */
  var meas;
  function fitSelects() {
    var sels = document.querySelectorAll('cart-drawer .upform-swap__select');
    if (!sels.length) return;
    if (!meas) { meas = document.createElement('span'); meas.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;left:-9999px;top:0'; document.body.appendChild(meas); }
    sels.forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var cs = getComputedStyle(sel);
      meas.style.font = cs.font;
      meas.style.letterSpacing = cs.letterSpacing;
      meas.textContent = opt.textContent.trim();
      var w = Math.ceil(meas.getBoundingClientRect().width + parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) + 2);
      if (sel.style.width !== w + 'px') sel.style.width = w + 'px';
    });
  }
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.upform-swap__select')) fitSelects(); });
  (function () {
    var d = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (d && 'MutationObserver' in window) new MutationObserver(function () { setTimeout(fitSelects, 30); }).observe(d, { childList: true, subtree: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitSelects); else fitSelects();
  })();

  /* 4. Kurv-timer: kurven gemmes i 10 min. fra første vare. Når tiden er gået, tømmes den
        rigtigt (så teksten er sand). Starttidspunktet huskes pr. kurv i browseren. */
  var KEY = 'hs_cart_timer';
  var LIMIT = 10 * 60 * 1000;
  var clearing = false;
  function store(v) { try { if (v) localStorage.setItem(KEY, JSON.stringify(v)); else localStorage.removeItem(KEY); } catch (e) {} }
  function stored() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function expire() {
    if (clearing) return;
    clearing = true;
    fetch(root() + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function () { return fetch(root() + '?sections=cart-drawer,cart-icon-bubble'); })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        store(null);
        /* Tegn kurv og kurv-ikon igen uden at åbne kurven */
        var parse = function (html, sel) { var d = new DOMParser().parseFromString(html || '', 'text/html').querySelector(sel); return d ? d.innerHTML : null; };
        var cd = document.getElementById('CartDrawer');
        var cdHtml = parse(sections['cart-drawer'], '#CartDrawer');
        if (cd && cdHtml !== null) cd.innerHTML = cdHtml;
        var bub = document.getElementById('cart-icon-bubble');
        var bubHtml = parse(sections['cart-icon-bubble'], '.shopify-section');
        if (bub && bubHtml !== null) bub.innerHTML = bubHtml;
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.add('is-empty');
      })
      .catch(function () {})
      .then(function () { clearing = false; });
  }
  function tick() {
    var els = document.querySelectorAll('[data-hs-timer]');
    if (!els.length) { if (!document.querySelector('cart-drawer .cart-item')) store(null); return; }
    var token = els[0].getAttribute('data-token') || 'x';
    var st = stored();
    if (!st || st.token !== token) { st = { token: token, start: Date.now() }; store(st); }
    var left = Math.max(0, LIMIT - (Date.now() - st.start));
    var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
    var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    document.querySelectorAll('[data-hs-timer-t]').forEach(function (t) { t.textContent = txt; });
    if (left <= 0) expire();
  }
  setInterval(tick, 1000);
  tick();
})();
